import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";

import { api } from "@/core/api/client";
import { useT } from "@/core/i18n";
import { useSession } from "@/core/state/session";

type Item = { id: string; title: string; severity: string; read?: boolean; status?: string };

export function AnnouncementBanner() {
  const t = useT();
  const identity = useSession((state) => state.identity);
  const [hidden, setHidden] = useState<string[]>(() => {
    const raw = sessionStorage.getItem("owo:announcement-hide");
    return raw ? raw.split(",") : [];
  });
  const query = useQuery({
    queryKey: ["announcement-banner", identity?.tenantSlug, identity?.userId],
    enabled: Boolean(identity?.tenantSlug),
    retry: false,
    queryFn: () => api.announcements(identity!.tenantSlug) as Promise<{ items?: Item[] }>,
  });
  const item = (query.data?.items ?? []).find((entry) => (entry.severity === "warning" || entry.severity === "critical") && !entry.read && !hidden.includes(entry.id) && entry.status !== "draft");
  if (!item) return null;
  function dismiss() {
    const next = [...hidden, item!.id];
    setHidden(next);
    sessionStorage.setItem("owo:announcement-hide", next.join(","));
  }
  return (
    <div className={`announcement-banner is-${item.severity}`} role="status">
      <span><b>{t(`announcements.severityValue.${item.severity}` as "announcements.severityValue.warning")}</b> {item.title}</span>
      <span>
        <Link to={`/announcements/${item.id}`}>{t("announcements.view")}</Link>
        <button type="button" onClick={dismiss}>{t("announcements.dismiss")}</button>
      </span>
    </div>
  );
}
